<template>
  <div id="app" ref="app">
    <router-view />
    <mfa-verify-dialog
      ref="mfaDialog"
      :visible.sync="showMfaDialog"
      @confirm="handleMfaConfirm"
      @close="handleMfaClose"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'App',
  mounted() {
    // this.$utils.toLocaleString()
  },
  computed: {
    ...mapState({
      showMfaDialog: state => state.mfaAndOTP.showMfaDialog
    })
  },
  methods: {
    handleMfaConfirm(mfaCode) {
      this.$store.dispatch('executeMfaCallback', mfaCode)
    },
    handleMfaClose() {
      this.$store.dispatch('hideMfaDialog')
    }
  }
}
</script>
<style scoped>
/* #app{
  min-width: 1200px;
} */

</style>
